import { useParams, Navigate } from 'react-router-dom';

/**
 * Deprecated alias — MCP server detail now lives at /app-tool-provider/:id
 * (unified ToolProviderDetail handles all kinds). This keeps bookmarks to
 * /mcp-server/:id working while consolidating to a single detail screen.
 * The platform's own MCP server at /mcp (services/mcpServer.js) is unrelated.
 */
export default function McpServerDetail() {
  const { id } = useParams();
  return <Navigate to={`/app-tool-provider/${id}`} replace />;
}
